<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">יצירת פרופיל רופא</h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="w-full l-align-spaceBetween pref-detail t-row">
    <input-wrap
      label="{{ 'translate.general.doctor' | translate }}"
      cssClass="l-cell-spread"
    >
      <p-select
        class="t-input--colored"
        [options]="doctorList"
        [(ngModel)]="doctor"
        [placeholder]="'translate.general.choose' | translate"
        [optionLabel]="'label'"
        appendTo="body"
        [filter]="true"
        [resetFilterOnHide]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-select>
    </input-wrap>
  </div>

  <div class="l-align-end footer">
    <button
      [disabled]="saving || !saveEnabled()"
      (click)="save()"
      class="t-button success"
    >
      יצירה
    </button>
  </div>
</div>
